export default {
    reportSettings: {
        machine: null,
        process: null,
        workspace: null
    },
    hasReportSettings: false,
    reportsLoading: false,
    workspaces: [],
    machineProcesses: [],
    detailedReports: [],
    reportOutOfSequenceCodes: [],
    shippingGroups: [],
    plateOrderReasons: [],
    defaultProductionProcess: null,
    reportItemOrdersFilters: setInitialReportItemOrdersFilters(),
    setInitialReportItemOrdersFilters: setInitialReportItemOrdersFilters,
}

function setInitialReportItemOrdersFilters() {
    return {
        shippingGroupCodes: 'S,B,W,C' // Strykow,Bydgoszcz,WMD,Czeskie,
    }
}